module.exports = __webpack_public_path__ + "img/Paperless Dark.57852b4b.svg";